<div class="job-info">Job: {{ jobNumber }}</div>
<div class="order-container">
  <div class="order-block" *ngFor="let order of requiredTags">
    <div class="order-info">Order: {{ order.orderNumber }}</div>
    <div class="customer-info">Customer: {{ order.customerName }}</div>
    <div class="tags-container">
      <div *ngFor="let tag of order.tags">
        <div class="tag-name" [ngClass]="getTagClass(tag)">
          {{ tag.tagEntity.name }}
        </div>
      </div>
    </div>
  </div>
</div>
